// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import Enumerable from "linq";
import {SimSystemExtendedService, SimTrainingRoomService} from "@services";
import {TrainingRoomType} from "@models";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {Translations} from "@translations";

export interface OSCE_TRAINING_ROOM_SELECTION_DIALOG_INPUT extends MatDialogDataBaseInput {
	trainingRoomIds: string[];
	// no value means both!
	filter?: TrainingRoomType;
}

export interface OSCE_TRAINING_ROOM_SELECTION_DIALOG_OUTPUT extends MatDialogDataBaseOutput {
	checkTrainingRoomIds: string[];
}

@Component({
	selector: "sim-osce-training-room-selection-dialog",
	templateUrl: "./osce-training-room-selection-dialog.component.html",
	styleUrls: ["./osce-training-room-selection-dialog.component.scss"],
	standalone: false,
})
export class OsceTrainingRoomSelectionDialogComponent extends BasicMaterialDialog<
	OsceTrainingRoomSelectionDialogComponent,
	OSCE_TRAINING_ROOM_SELECTION_DIALOG_INPUT,
	OSCE_TRAINING_ROOM_SELECTION_DIALOG_OUTPUT
> {
	T = Translations;

	// private members
	// ----------------------------------------
	public trainingRooms: any[] = null;

	constructor(
		private simSystemService: SimSystemExtendedService,
		private simTrainingRoomService: SimTrainingRoomService,
		_injector: Injector,
	) {
		super(_injector);
		this.init();
	}

	protected init() {
		this.simTrainingRoomService.getTrainingRooms().then((getTrainingRoomsResult) => {
			if (getTrainingRoomsResult) {
				this.trainingRooms = getTrainingRoomsResult;

				// Apply filter
				// --------------------------
				if (this.data.filter) {
					this.trainingRooms = Enumerable.from(this.trainingRooms)
						.where((trainingRoom) => {
							if (this.data.filter) {
								return trainingRoom.type === this.data.filter;
							}
						})
						.toArray();
				}

				// Set checked state
				// --------------------------
				if (this.data.trainingRoomIds && this.trainingRooms && this.trainingRooms.length > 0) {
					for (const trainingRoom of this.trainingRooms) {
						trainingRoom.checked = this.data.trainingRoomIds.indexOf(trainingRoom.trainingRoomId) >= 0;
					}
				}
			}
		});
	}

	public ok() {
		const checkTrainingRoomIds = Enumerable.from(this.trainingRooms)
			.where((trainingRoom) => {
				return trainingRoom.checked;
			})
			.select((trainingRoom) => {
				return trainingRoom.trainingRoomId;
			})
			.toArray();
		this.close({action: "ok", checkTrainingRoomIds: checkTrainingRoomIds});
	}
}
